import { render, staticRenderFns } from "./arule2.vue?vue&type=template&id=29aba65d&"
import script from "./arule2.vue?vue&type=script&lang=js&"
export * from "./arule2.vue?vue&type=script&lang=js&"
import style0 from "./arule2.vue?vue&type=style&index=0&id=29aba65d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports